<template lang="pug">
  v-layout.box-iconTextIcon-formatter(style="padding: 0.4em 0em")
    v-flex.icon-text
      img(:src="iconTextProp")
    v-flex.box-text
      span(style="font-size: 14px") {{textProp}}
    v-flex.icon-flag
      img(:src="iconFlagProp")  
</template>

<script>
export default {
  props: [
    'textProp',
    'iconTextProp',
    'iconFlagProp',
    'iconTextPropHover'
  ],
  data() {
    return {
      styleHover: ''
    }
  },
  computed: {
    hoverMethod() {
      this.styleHover = 'url(' + this.iconTextPropHover + ')' + 'no-repeat'


      return { 'imgHover': this.styleHover }
      // return this.iconTextPropHover ? 'box-iconTextIcon-hover-formatter' : ''
    }
  }

}
</script>

<style scoped>
@media (min-width : 360px) {
  .icon-text {
    display: flex;
    max-width: fit-content;
    margin-right: 10px;
    height: 27px;
  }

  .box-text {
    display: flex;
    align-self: center;
    font-size: 20px !important;
  }

  .box-text span {
    font-size: 17px !important;
  }

  .icon-flag {
    display: flex;
    align-self: center;
    max-width: fit-content;
    height: 24px;
    
  }
}

@media (min-width : 1024px) {
  .box-text span {
    font-size: 14px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/generic/IconTextIcon.vue